<template> 
  <div class="home net-status-home">
    <Layout layoutType="HARDLIST" isRevenue="true" pageTitle="标准节点">
      <BasiceLayout title="账单详情">
        <div class="hardware-content">
          <div class="hardware-search-wrap" align='center'>
          <span class="revenue-date-wrap">{{$t('revenueDate')}}</span>
          <el-select v-model="selectDate" filterable @change="searchDate">
            <el-option v-for="item in queryDate" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <span class="search-text">{{$t('search_mac_address')}}</span>
          <el-input class="search-mac-input" v-model="searchMacAddress" placeholder="回车搜索" @keydown.enter.native="searchEnter"></el-input>
          <div class="float-right">
            <div v-if="billList.length" class="button" @click="downloadBill">{{ $t('download_bill') }}</div>
            <div v-else class="button button-disabled">{{ $t('download_bill') }}</div>
            <div v-if="showBillBtn" class="button billbtn" @click="confirmBill">{{ $t('confirm_bill') }}</div>
            <div v-else class="button button-disabled">{{$t('confirmed')}}</div>
          </div>
        </div>
          <el-table id="out-table" :data="billList.slice((currentPage-1)*pageSize,currentPage*pageSize)" empty-text="无">
            <el-table-column prop="hostName" :label="$t('mac_address')" align='center'></el-table-column>
            <el-table-column prop="task" :label="$t('task')" align='center'></el-table-column>
            <el-table-column prop="operator" :label="$t('operator')" align='center'></el-table-column>
            <el-table-column prop="bps" :label="$t('billing_bandwidth')" align='center'></el-table-column>
            <el-table-column prop="effectiveDays" :label="$t('effective_days')" align='center'></el-table-column>
            <el-table-column :label="$t('search_bandwidth')" align='center'>
              <template slot-scope="scope">
                <div class="add-note-button button bonus-cursor" @click="getBpsDetails(scope.row)">{{$t('check')}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="bp" :label="$t('BP_earnings')" align='center'></el-table-column>
            <el-table-column prop="price" :label="$t('RMB_earnings')" align='center'></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </BasiceLayout>
    </Layout>
    <el-dialog title="带宽详情" :visible.sync="showBpsDialog" width="70%" center>
      <div class="addnote-dialog-wrap" v-loading="loading">
        <LineCharts :chartData="chartData"></LineCharts>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import XLSX from 'xlsx'
  import FileSaver from 'file-saver';
  import { Message } from "element-ui";
  import { mapState, mapActions, mapMutations } from "vuex";
  import BasiceLayout from "@/components/Common/BasicLayout.vue";
  import Layout from "@/components/DatePanel/Layout.vue";
  import LineCharts from "@/components/Common/LineCharts.vue";
  
  export default {
    name: "home",
    components: {
      BasiceLayout,
      Layout,
      LineCharts
    },
    data() {
      return {
        selectDate: '',
        searchMacAddress: '',
        showBillBtn: false,
        billList: [],
        pageSize: 20,
        total: '',
        currentPage: 1,
        showBpsDialog: false,
        chartData:{},
        loading: false
      }
    },
    computed: mapState({
      queryDate: () => {
        let queryDate = [];
        let endDay = moment().utc().startOf("month");
        let i = 0;

        while (i < 3) {
          i++;
          queryDate.push(
            moment(endDay)
            .startOf("month")
            .subtract(i,'month')
            .format('YYYY-MM')
          );
        }
        return queryDate;
      }
    }),
    methods: {
      ...mapActions([
        "getBillDetails",
        "updateBillStatus",
        "getBillBps"
      ]),
      async getBill(date) {
        const params = { date, hostName:this.searchMacAddress };
        const res = await this.getBillDetails(params);
        if(res.code == 200) {
          res.bills.map((item)=>{
            item.price = item.price.toFixed(2);
            item.bp = item.bp.toFixed(2);
          })
          this.billList = res.bills;
          this.total = res.bills.length;
          this.showBillBtn = res.bills[0].status ? false : true;
        } else {
          Message.error('获取账单详情失败');
        }
      },
      confirmBill(){
        this.$confirm('是否确认该月账单? （如有异议请联系小溪/大海）', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(async ()=>{
         const result = await this.updateBillStatus({ date:this.selectDate });
         if(result.code == 200) {
           Message.success('操作成功，当月已确认');
           this.showBillBtn = false;
         } else {
           Message.error('操作失败，请稍后重试');
         }
       })
      },
      async getBpsDetails(row) {
        this.loading = true;
        const bps95List = eval('('+ row.day95List +')');
        this.showBpsDialog = true;
        if(bps95List) {
          let lineChartData = {
            columns:['日期','带宽'],
            rows:[]
          }
          bps95List.map((item)=>{
            lineChartData.rows.push({
              '日期':item.date,
              '带宽': Number(item.bps)
            })
          })
          this.chartData = lineChartData;
          this.loading = false;
        } else {
          Message.error('获取带宽详情失败');
        }
      },
      downloadBill() {
        let tables = document.getElementById("out-table");
        let table_book = XLSX.utils.table_to_book(tables);
        var table_write = XLSX.write(table_book, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([table_write], { type: "application/octet-stream" }),
            "账单详情.xlsx"
          );
        } catch (e) {
          Message.error('下载账单失败');
        }
        return table_write;
      },
      searchDate(){
        this.getBill(this.selectDate);
      },
      searchEnter(e){
        var keycode = window.event ? e.keyCode : e.which;
        if(keycode == 13){
          this.getBill(this.selectDate);
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      }
    },
    created() {
      this.selectDate = this.queryDate[0];
      this.getBill(this.queryDate[0]);
    }
  };
</script>

<i18n>
  {
    "zn": {
      "confirm_bill": "账单确认",
      "download_bill": "下载",
      "confirmed":"当月已确认",
      "revenueDate": "查询月份",
      "search_mac_address": "主机名搜索",
      "mac_address":"主机名",
      "task":"业务",
      "operator":"运营商",
      "billing_bandwidth":"计费带宽（Gbps）",
      "effective_days":"有效天数",
      "check":"查看",
      "search_bandwidth":"查看带宽",
      "BP_earnings":"收益（BP）",
      "RMB_earnings":"收益（RMB）"
    },
    "en": {
      "confirm_bill": "Confirm",
      "download_bill": "Download",
      "confirmed":"Confirmed",
      "revenueDate": "Date（UTC）",
      "search_mac_address": "Mac Address",
      "mac_address":"Host name",
      "task":"Task",
      "operator":"Operator",
      "billing_bandwidth":"Billing bandwidth",
      "effective_days":"The effective day",
      "check":"Check",
      "search_bandwidth":"Bandwidth",
      "BP_earnings":"Earnings(BP)",
      "RMB_earnings":"Earnings(RMB)"
    }
  }
</i18n>


<style scoped="scoped">
  .billbtn{
    background: red; 
    margin:3px 0;
  }
  .revenue-date-wrap{
    line-height: 40px;
  }
  .hardware-search-wrap{
    display: block;
  }
  .add-note-button{
    background: #0DB4C5;
  }
  .disabledBtn{
    width: 90px; 
    height: 35px; 
    text-align: center; 
    border-radius:0; 
    font-weight: 400; 
    font-style: PingFangSC-Regular;
    float: right; 
    padding: 0;
  }
</style>
<style>
  .el-message-box__wrapper .el-message-box{
    width: 420px;
  }
</style>